<template>
  <div v-if="showPointsBanner" class="points-banner">
    <p>
      {{ customerName }}, you have {{ creditBalance }} ({{ pointsBalance }}
      points) to use at Checkout.
    </p>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { businessLogic } from "@/config.js";
export default {
  name: "PointsBanner",
  computed: {
    ...mapState("auth", ["customer"]),
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapGetters("app", ["currencyCode"]),
    customerName() {
      return this.customer?.firstName || "";
    },
    pointsBalance() {
      return parseFloat(this.customer?.approvedPoints?.value) || 0;
    },
    creditBalance() {
      if (!this.currencyCode) return;
      const value =
        this.pointsBalance / businessLogic.loyaltyPointsConversion || 0;

      return this.$filters.toCurrency(value, this.currencyCode, 0);
    },
    showPointsBanner() {
      const creditValue =
        this.pointsBalance / businessLogic.loyaltyPointsConversion || 0;
      const minimumValue = 0.99;

      const aboveMinimumValue = creditValue > minimumValue;

      return this.isLoggedIn && aboveMinimumValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.points-banner {
  background-color: #fafafa;
  padding: 20px 0;
  text-align: center;
  @include utility-body(15px);
}
</style>
